import React, { Component } from 'react'
import Tabbar from '../../components/tabbar'

export default class index extends Component {
    render() {
        return (
            <div>
                待办项
                <Tabbar {...this.props}></Tabbar>
            </div>
        )
    }
}
